import styled from '@emotion/styled';
import GenerateQrCode from 'qrcode';
import React, { useEffect, useRef } from 'react';

import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  border: boolean,
  children?: React.ReactNode,
  qrCodeContent: string,
};

export const QrCode = withSpacingStyles(({ border, children, qrCodeContent, text = '', ...rest }: Props) => {
  const ref = useRef();

  useEffect(() => {
    if (qrCodeContent) {
      GenerateQrCode.toCanvas(
        ref.current?.querySelector('canvas'),
        qrCodeContent,
        { errorCorrectionLevel: 'M', margin: 0, version: 1, width: 126 * window.devicePixelRatio },
      );
    }
  }, [qrCodeContent]);

  return (
    (qrCodeContent || !!children) && (
      <QrCodeWrapper border={border} data-test="qr-code" ref={ref} {...rest}>
        <Canvas hidden={!qrCodeContent} ref={ref} />
        {children}
      </QrCodeWrapper>
    )
  );
});

const Canvas = styled.canvas`
  max-width: 126px;
  max-height: 126px;
`;

const QrCodeWrapper = styled('div')(({ border, theme }) => `
  ${border ? `border: ${theme.stroke.light};` : ''}
  border-radius: ${theme.borderRadius.medium};
  text-align: center;
  background-color: ${theme.color.white};
`);
